import parsePhoneNumber from "libphonenumber-js";
import type { CountryCode } from "@/lib/phone/countryCode";
import {
  DEFAULT_PHONE_COUNTRY,
  defaultPhoneCountryForLanguage,
} from "@/lib/locales";

function countryFromIso(value: string | undefined): CountryCode | undefined {
  if (!value) return undefined;
  const code = value.trim().toUpperCase();
  if (code.length === 2) return code as CountryCode;
  return undefined;
}

/** Default calling country for the phone widget (English locale fallback). */
export function resolveDefaultPhoneCountry(params: {
  registeredCountry?: string;
  language?: string;
}): CountryCode {
  return (
    countryFromIso(params.registeredCountry) ??
    defaultPhoneCountryForLanguage(params.language) ??
    DEFAULT_PHONE_COUNTRY
  );
}

/** Infer country from a stored E.164 value when hydrating the form. */
export function countryFromE164(
  value: string | undefined,
): CountryCode | undefined {
  if (!value?.trim()) return undefined;
  const country = parsePhoneNumber(value.trim())?.country;
  return country ?? undefined;
}
